import { useAuth0 } from "@auth0/auth0-react"
import React, { useRef, useState } from "react"
import { Button, Card, CardContent, CardDescription, Feed, FeedContent, FeedEvent, FeedExtra, FeedSummary, Form, Icon, Input, Message, Segment, SegmentGroup } from "semantic-ui-react"
import BifrostButton from "../../../../Components/BifrostElementComponent/BifrostButton/BifrostButton"
import Loader from "../../../../Components/BifrostPageComponent/Loader/Loader"
import { usePatchData } from "../../../../Hooks/FetchHooks/PatchDataService/usePatchData"
import { isSuperAdminOrResellerAdmin, isSuperAdminOrResellerAdminOrAdmin } from "../../../../Utils/util"
import { useUserDetailSegment } from "./hooks/useUserDetailSegment"

const initialValueState = {
	nickname: "",
	role: ""
}

const initialState = {
	nickname: false,
	role: false
}

const optionsRole = [
	{ key: "admin", value: "Admin", text: "Admin" },
	{ key: "user", value: "User", text: "User" }
]

const UserDetailSegment = ({ data, setData }) => {
	const { user } = useAuth0()

	const [patchLoading, setPatchLoading] = useState(initialState)
	const [values, setValues] = useState(data.name ? { name: data.name } : initialValueState)
	const [changeEnabled, setChangeEnabled] = useState(initialState)
	const [showChangeErrorMessage, setShowChangeErrorMessage] = useState(initialState)
	const [showEditIcon, setShowEditIcon] = useState(initialState)
	// const [validated, setValidated] = useState(initialValidatedState)
	// const [validated, setValidated] = useState(initialValidatedState)
	const { patchItem } = usePatchData()
	const inputRef = useRef({ nickname: null, role: null })

	const { state, copyDirectTunnelLink } = useUserDetailSegment(data)

	const enableChange = (field) => {
		setChangeEnabled({ ...changeEnabled, [field]: true })
		setTimeout(() => {
			inputRef[field].current.focus()
		}, 100)
	}

	const updateField = (e, name, value) => {
		if (!name) {
			name = e.target.name
			value = e.target.value
		}
		setValues({
			...values,
			[name]: value
		})
	}

	const submitHandler = (field) => {
		// set patch loading based on field
		setPatchLoading({ ...patchLoading, [field]: true })
		let patchObject = {}
		patchObject[field] = values[field]
		patchItem("/api/v2/user/" + data.id, patchObject, null)
			.then(() => {
				setData({
					...data,
					[field]: values[field]
				})
				// setOpenModal(false);
			})
			.catch(() => {
				// setValidated({...initialValidatedState});
				// setValues({...initialValueState});
				setShowChangeErrorMessage({ ...showChangeErrorMessage, [field]: true })
			})
			.finally(() => {
				setChangeEnabled({ ...changeEnabled, [field]: false })
				setShowEditIcon({ ...showEditIcon, [field]: false })
				setPatchLoading({ ...patchLoading, [field]: false })
				updateField(null, field, data[field])
			})
	}

	const cancelHandler = (field) => {
		setChangeEnabled({ ...changeEnabled, [field]: false })
		setShowEditIcon({ ...showEditIcon, [field]: false })
		updateField(null, field, data[field])
	}

	const getRoleOptions = () => {
		if (isSuperAdminOrResellerAdmin(user)) {
			return optionsRole.concat({ key: "reselleradmin", value: "ResellerAdmin", text: "ResellerAdmin" })
		} else {
			return optionsRole
		}
	}

	return (
		<SegmentGroup horizontal style={{ marginTop: "0px" }}>
			<Segment style={{ width: "50%" }}>
				<Feed>
					<FeedEvent className="user-event-margin">
						<FeedContent>
							<FeedSummary content={"Name"} />
							{patchLoading["nickname"] ? (
								<Loader backgroundColor="white" inverted height="1px" minHeight="55px" />
							) : (
								<>
									{showChangeErrorMessage["nickname"] && <Message error content={"Name change failed, please try again"} />}
									{!changeEnabled["nickname"] ? (
										<FeedExtra
											text
											onClick={() => enableChange("nickname")}
											className={"user-change-hover"}
											onMouseLeave={() => setShowEditIcon({ ...showEditIcon, nickname: false })}
											onMouseEnter={() => setShowEditIcon({ ...showEditIcon, nickname: true })}
										>
											{data.nickname} {showEditIcon["nickname"] && <Icon style={{ float: "right" }} name="edit" />}
										</FeedExtra>
									) : (
										<FeedExtra style={{ marginTop: "0px" }} text>
											<Card style={{ width: "100%" }}>
												<CardContent className="user-change">
													<CardDescription>
														<Input
															style={{ border: "none", width: "100%" }}
															ref={inputRef["nickname"]}
															className={"user-change-noborder"}
															name="nickname"
															defaultValue={data.nickname}
															onChange={(e) => updateField(e)}
														/>
													</CardDescription>
												</CardContent>
											</Card>
											<div style={{ display: "flex", justifyContent: "right" }}>
												<BifrostButton onClick={() => submitHandler("nickname")} color="blue" style={{ width: "90px" }}>
													Save
												</BifrostButton>
												<BifrostButton
													color="gray"
													onClick={() => {
														cancelHandler("nickname")
													}}
													style={{ width: "90px" }}
												>
													Cancel
												</BifrostButton>
											</div>
										</FeedExtra>
									)}
								</>
							)}
						</FeedContent>
					</FeedEvent>
					<FeedEvent className="user-event-margin">
						{/* <FeedLabel image={null} /> */}
						<FeedContent>
							{/* <FeedDate content={"dd"} /> */}
							<FeedSummary content={"Email"} />
							<FeedExtra text className={"user-change-disabled"} content={data.email} />
						</FeedContent>
					</FeedEvent>
					<FeedEvent className="user-event-margin">
						<FeedContent>
							<FeedSummary content={"Role"} />
							{patchLoading["role"] ? (
								<Loader backgroundColor="white" inverted height="1px" minHeight="55px" />
							) : (
								<>
									{showChangeErrorMessage["role"] && <Message error content={"Role change failed, please try again"} />}
									{!changeEnabled["role"] ? (
										<FeedExtra
											text
											onClick={() => enableChange("role")}
											className={"user-change-hover"}
											onMouseLeave={() => setShowEditIcon({ ...showEditIcon, role: false })}
											onMouseEnter={() => setShowEditIcon({ ...showEditIcon, role: true })}
										>
											{data.role} {showEditIcon["role"] && <Icon style={{ float: "right" }} name="edit" />}
										</FeedExtra>
									) : (
										<FeedExtra className="user-dropdown" style={{ marginTop: "5px" }} text>
											{/* <Card style={{ width: "100%" }}>
															<CardContent className='user-change'>
														<CardDescription> */}
											<Form.Dropdown
												style={{ marginBottom: "14px" }}
												fluid
												search
												selection
												defaultValue={data.role}
												onChange={(e, { name, value }) => updateField(e, name, value)}
												name="role"
												placeholder="Select role"
												options={getRoleOptions()}
											/>
											{/* <Input style={{ border: "none", width: "100%" }} ref={inputRef["role"]} className={"user-change-noborder"} name="role" defaultValue={data.role} onChange={(e) => updateField(e)} /> */}
											{/* </CardDescription>
															</CardContent>
														</Card> */}
											<div style={{ display: "flex", justifyContent: "right" }}>
												<BifrostButton onClick={() => submitHandler("role")} color="blue" style={{ width: "90px" }}>
													Save
												</BifrostButton>
												<BifrostButton
													color="gray"
													onClick={() => {
														cancelHandler("role")
													}}
													style={{ width: "90px" }}
												>
													Cancel
												</BifrostButton>
											</div>
										</FeedExtra>
									)}
								</>
							)}
						</FeedContent>
					</FeedEvent>
					<FeedEvent className="user-event-margin">
						{/* <FeedLabel image={null} /> */}
						<FeedContent>
							{/* <FeedDate content={"dd"} /> */}
							<FeedSummary content={"Groups"} />
							<FeedExtra text content={data.groups && data.groups.length > 0 ? data.groups.map((group) => <div key={group.id}>{group.name}</div>) : "None"} />
						</FeedContent>
					</FeedEvent>
				</Feed>
			</Segment>
			<Segment style={{ width: "50%" }}>
				<Feed>
					<FeedEvent className="user-event-margin">
						{/* <FeedLabel image={image} /> */}
						<FeedContent>
							{/* <FeedDate content={date} /> */}
							<FeedSummary content={"Last Login"} />
							<FeedExtra text content={data.last_login ? data.last_login : "Unknown"} />
						</FeedContent>
					</FeedEvent>
					<FeedEvent className="user-event-margin">
						{/* <FeedLabel image={null} /> */}
						<FeedContent>
							{/* <FeedDate content={"dd"} /> */}
							<FeedSummary content={"Last Session"} />
							<FeedExtra text content={data.last_session ? data.last_session : "Unknown"} />
						</FeedContent>
					</FeedEvent>
					{isSuperAdminOrResellerAdminOrAdmin(user) && (process.env.REACT_APP_THEME === "bifrost" || process.env.REACT_APP_THEME === "advenica") && (
						<FeedEvent className="user-event-margin">
							{/* <FeedLabel image={null} /> */}
							<FeedContent>
								{/* <FeedDate content={"dd"} /> */}
								<FeedSummary content={"Direct Tunnel Status"} />
								<FeedExtra text>
									{state.userDirectTunnelStatus === null ? (
										"Unknown"
									) : state.userDirectTunnelStatus === true ? (
										"Active"
									) : (
										<Segment basic style={{ padding: 0 }}>
											User not setup yet, please request the user to register by using this link:
											<Button basic floated="right" size="tiny" compact onClick={copyDirectTunnelLink} color={state.copyButtonColor}>
												Copy Link
											</Button>
										</Segment>
									)}
								</FeedExtra>
							</FeedContent>
						</FeedEvent>
					)}
				</Feed>
			</Segment>
		</SegmentGroup>
	)
}

export default UserDetailSegment
